import { defineMessages } from "react-intl";

export const messages = defineMessages({
  shortName: {
    id: "ari.management.actionsBar.shortName",
    defaultMessage: "Short name"
  },
  fullName: {
    id: "ari.management.actionsBar.fullName",
    defaultMessage: "Full name"
  },
  showComplements: {
    id: "ari.management.actionsBar.showComplements",
    defaultMessage: "Show complements"
  },
  hideComplements: {
    id: "ari.management.actionsBar.hideComplements",
    defaultMessage: "Hide complements"
  },
  enableEdition: {
    id: "ari.management.actionsBar.enableEdition",
    defaultMessage: "Enable edition"
  }
});